import { useState } from 'react';
import { App, Button, Card, Form, Input, Typography } from 'antd';
import { useNavigate } from 'react-router';
import { PASSWORD_MIN } from '@technic/contracts';
import { authApi, useAuth } from '@entities/session';
import { sessionErrorMessage } from '@entities/session';

export function ChangePasswordPage() {
  const { user, setUser, logout } = useAuth();
  const { message } = App.useApp();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: { currentPassword: string; newPassword: string }) => {
    setLoading(true);
    try {
      const res = await authApi.changePassword(values);
      setUser(res.user);
      message.success('Пароль изменён');
      // Туда же, куда после входа: раздел учётке выбирает стартовая страница, а прежний
      // `/waste` для роли без вывоза заканчивался этой же формой — круг замыкался.
      navigate('/', { replace: true });
    } catch (e) {
      message.error(sessionErrorMessage(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
      }}
    >
      {/* Карточка держит прежнюю ширину, пока экран её вмещает, и сжимается на телефоне. */}
      <Card style={{ width: '100%', maxWidth: 420 }}>
        <Typography.Title level={3} style={{ textAlign: 'center' }}>
          Смена пароля
        </Typography.Title>
        {user?.mustChangePassword ? (
          <Typography.Paragraph type="warning" style={{ textAlign: 'center' }}>
            Требуется сменить пароль перед продолжением работы.
          </Typography.Paragraph>
        ) : null}
        <Form layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item
            name="currentPassword"
            label="Текущий пароль"
            rules={[{ required: true, message: 'Введите текущий пароль' }]}
          >
            <Input.Password autoComplete="current-password" size="large" />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="Новый пароль"
            rules={[
              { required: true, min: PASSWORD_MIN, message: `Не менее ${PASSWORD_MIN} символов` },
            ]}
          >
            <Input.Password autoComplete="new-password" size="large" />
          </Form.Item>
          <Form.Item
            name="confirm"
            label="Повторите новый пароль"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: 'Повторите пароль' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) return Promise.resolve();
                  return Promise.reject(new Error('Пароли не совпадают'));
                },
              }),
            ]}
          >
            <Input.Password autoComplete="new-password" size="large" />
          </Form.Item>
          <Button type="primary" htmlType="submit" size="large" block loading={loading}>
            Сохранить
          </Button>
        </Form>
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          {/* Возврат — только когда смену затеяли добровольно: форму открывают пунктом меню
              учётной записи и из кабинета водителя, а обратной дороги с неё не было ни у кого —
              передумал, значит либо меняй пароль, либо выходи из портала. При обязательной смене
              кнопки нет: она обходила бы требование, ради которого в `ProtectedRoute` стоит
              проверка `mustChangePassword`. */}
          {user?.mustChangePassword === false ? (
            <Button type="link" onClick={() => navigate('/')}>
              Вернуться в портал
            </Button>
          ) : null}
          <Button type="link" onClick={() => void logout().then(() => navigate('/login'))}>
            Выйти
          </Button>
        </div>
      </Card>
    </div>
  );
}
